export const GAMES_SOUND_TYPE = {
  win: {
    name: 'win',
    src: './assets/audio/games/win.wav'
  }
}

export const GAMES_DEFAULT_ERROR_MESSAGE = 'Oops! Something went wrong. Try again later';
